import { fetchApi } from 'api/index'

export const restoreAccountApi = () =>
  fetchApi('/settings/restore_account/restoreAccount', {
    method: 'POST',
  })
